import { render, staticRenderFns } from "./OnboardingTour.vue?vue&type=template&id=4b391dd8&scoped=true"
import script from "./OnboardingTour.vue?vue&type=script&lang=ts"
export * from "./OnboardingTour.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingTour.vue?vue&type=style&index=0&id=4b391dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b391dd8",
  null
  
)

export default component.exports